import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-400">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-blue-600 to-cyan-500 flex items-center justify-center">
                <span className="text-white font-bold text-sm">A</span>
              </div>
              <span className="text-white font-semibold">Apexum Partners</span>
            </div>
            <p className="text-sm leading-relaxed text-slate-400 max-w-sm">
              Connecting qualified clinics with trusted pharmacy, lab, fulfillment, and telehealth infrastructure pathways.
            </p>
            <p className="text-xs mt-4 text-slate-500">
              Apexum Partners does not provide medical advice, prescribe medication, or support research-use-only products for human use.
            </p>
          </div>

          <div>
            <h4 className="text-white text-sm font-medium mb-4">Platform</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/how-it-works" className="hover:text-white transition-colors">How It Works</Link></li>
              <li><Link to="/for-clinics" className="hover:text-white transition-colors">For Clinics</Link></li>
              <li><Link to="/for-partners" className="hover:text-white transition-colors">For Partners</Link></li>
              <li><Link to="/compliance" className="hover:text-white transition-colors">Compliance</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-medium mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-white transition-colors">Terms of Use</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-slate-500">
            &copy; {new Date().getFullYear()} Apexum Partners. All rights reserved.
          </p>
          <p className="text-xs text-slate-500">
            Pharmacy, fulfillment, and vendor pathways are subject to qualification, partner review, and applicable law.
          </p>
        </div>
      </div>
    </footer>
  );
}
